















import { Vue, Component } from "@/shared/vuepack";
import { Home } from "@/employee/route-names";
import { useBalanceTransferStore } from "@/employee/store/balanceTransfer";
import Button from "@/shared/components/ui/Button.vue";

@Component({
  components: {
    Button
  }
})
export default class Finish extends Vue {
  balanceTransferStore = useBalanceTransferStore();

  goToDashboard () {
    this.balanceTransferStore.clearState();
    this.$router.push({ name: Home });
  }
}
